<template>
  <div class="page-container">
    <!-- Print Controls -->
    <div class="print-controls">
      <Button
        icon="pi pi-print"
        label="Print"
        @click="print"
      />
    </div>

    <!-- Label Template -->
    <div class="pal-label">
      <div class="label-content">
        <table class="tg">
          <colgroup>
            <col style="width: 40mm">
            <col style="width: 70mm">
          </colgroup>
          <thead>
            <tr>
              <th
                class="tg-0lax"
                rowspan="2"
              >
                <img 
                  src="../../assets/logos/Symphony_Logo_Only.png" 
                  alt="Symphony Logo" 
                  class="logo"
                  @error="handleLogoError"
                >
              </th>
              <th class="tg-0lax">
                <div class="project-info">
                  <div>Project Name: {{ projectName }}</div>
                </div>
              </th>
            </tr>
            <tr>
              <th class="tg-0lax">
                <div>Project Number: {{ projectNumber }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="tg-0lax"
                colspan="2"
              >
                <div class="content">
                  <strong> {{ asset.name }}</strong>
                </div>
              </td>
            </tr>
            <tr>
              <td
                class="tg-0lax"
                colspan="2"
              >
                <div class="footer-colours">
                  <div class="colour-box red" />
                  <div class="colour-box blue" />
                </div>
              </td>
            </tr>
            <tr>
              <td
                class="tg-0lax"
                colspan="2"
              >
                <div class="footer-company">
                  I'm the PAL LABel footer, I contain group name, and colours
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const asset = ref({});
const projectName = ref('Project Alpha'); // This should come from your data
const projectNumber = ref('PRJ-001'); // This should come from your data
const logoError = ref(false);

onMounted(() => {
    // Decode the asset data from the URL
    const assetData = JSON.parse(decodeURIComponent(route.params.assetData));
    asset.value = assetData;
});

const handleLogoError = () => {
    logoError.value = true;
    console.error('Failed to load Symphony logo');
};

const print = () => {
    window.print();
};
</script>

<style scoped>
.page-container {
    padding: 20px;
}

.print-controls {
    margin-bottom: 20px;
    text-align: right;
}

.pal-label {
    width: 210mm; /* A5 width */
    height: 148mm; /* A5 height */
    padding: 10mm;
    margin: 0 auto;
    background: white;
}

.label-content {
    height: 100%;
}

.tg {
    border-collapse: separate;
    border-spacing: 0;
    width: 190mm; /* Total width of both columns */
    border-radius: 10px;
    overflow: hidden;
}

.tg td {
    border-color: black;
    border-style: solid;
    border-width: 0.5mm;
    font-family: Arial, sans-serif;
    font-size: 3.5mm;
    overflow: hidden;
    padding: 2.5mm;
    word-break: normal;
}

.tg th {
    border-color: black;
    border-style: solid;
    border-width: 0.5mm;
    font-family: Arial, sans-serif;
    font-size: 3.5mm;
    font-weight: normal;
    overflow: hidden;
    padding: 2.5mm;
    word-break: normal;
}

/* Round only the outer corners of the table */
.tg thead tr:first-child th:first-child {
    border-top-left-radius: 2.5mm;
}

.tg thead tr:first-child th:last-child {
    border-top-right-radius: 2.5mm;
}

.tg tbody tr:last-child td:first-child {
    border-bottom-left-radius: 2.5mm;
}

.tg tbody tr:last-child td:last-child {
    border-bottom-right-radius: 2.5mm;
}

.tg .tg-0lax {
    text-align: left;
    vertical-align: top;
}

.logo {
    height: 15mm;
    width: auto;
}

.project-info {
    padding: 1.5mm;
}

.project-info div {
    margin-bottom: 1.5mm;
}

.content {
    padding: 1.5mm;
    height: 75mm;
}

.footer-colours {
    height: 15mm;
    padding: 1.5mm;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5mm;
}

.colour-box {
    width: 45%;
    height: 10mm;
}

.colour-box.red {
    background-color: #FF0000;
}

.colour-box.blue {
    background-color: #0000FF;
}

.footer-company {
    width: 190mm;
    height: 5mm;
    padding: 1.5mm;
    margin: 0;
    border-top: 0.5mm solid black;
}

.accessory-item {
    margin: 1.5mm 0;
    padding-left: 2.5mm;
}

@media print {
    .print-controls {
        display: none;
    }

    .page-container {
        padding: 0;
    }

    .pal-label {
        width: 210mm;
        height: 148mm;
        padding: 0;
        margin: 0;
    }

    .label-content {
        border: none;
        padding: 10mm;
    }

    @page {
        size: A5 landscape;
        margin: 0;
    }
}
</style> 